// V2 port of v1's RootItemsDisplay — collapsible list of root products the
// WO contributes to. Each v2 WO has exactly one root_output_item, so this
// is always a single chip (visual slot preserved for 1-to-1 parity).

import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { AccountTree } from '@mui/icons-material';

export default function RootItemsDisplayV2({ step }) {
  if (!step?.root_output_item_id) return null;
  // If the root is the same as the output we're making, suppress.
  if (step.root_output_item_id === step.output_item_id) return null;

  return (
    <Box sx={{ mt: 0.5 }} onClick={(e) => e.stopPropagation()}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <AccountTree sx={{ fontSize: '0.9rem' }} />
        For:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.25, alignItems: 'center' }}>
        <Chip
          data-testid={`root-item-chip-${step.root_output_item_id}`}
          label={step.root_output_item_name || step.root_output_item_code}
          size="small"
          variant="outlined"
          sx={{
            height: 26,
            fontSize: '0.85rem',
            color: 'black',
            borderColor: 'grey.400',
            '& .MuiChip-label': { px: 1.5 },
          }}
        />
      </Box>
    </Box>
  );
}
